import { render } from "./StatisticsOccupation.vue?vue&type=template&id=14c4b5be&scoped=true"
import script from "./StatisticsOccupation.vue?vue&type=script&lang=js"
export * from "./StatisticsOccupation.vue?vue&type=script&lang=js"

import "./StatisticsOccupation.vue?vue&type=style&index=0&id=14c4b5be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c4b5be"]])

export default __exports__